export default "__VITE_ASSET__CG72lT1___"